module.exports = __webpack_public_path__ + "img/cotizacion.72eb9ee0.png";